import { render, staticRenderFns } from "./CentralCosts.vue?vue&type=template&id=f06f1fac&scoped=true"
import script from "./CentralCosts.vue?vue&type=script&lang=js"
export * from "./CentralCosts.vue?vue&type=script&lang=js"
import style0 from "./CentralCosts.vue?vue&type=style&index=0&id=f06f1fac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06f1fac",
  null
  
)

export default component.exports